import { Component, OnInit, Inject, Injector, OnChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/common/base/base.component';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { UserService } from 'src/app/components/catalogs/user-catalog/services/user.service';
// import { User } from '../../../../Services/Users/user';
// import { UserService } from '../../../../Services/Users/user.service';

@Component({
  selector: 'app-role-user',
  templateUrl: './role-user.component.html',
  styleUrls: ['./role-user.component.scss']
})
export class RoleUserComponent extends BaseComponent implements OnInit {
  public usersFiltered?: User[];
  public userSelected?: User;

  constructor(
    protected override injector: Injector,
    public dialogRef: MatDialogRef<RoleUserComponent>,
    @Inject(MAT_DIALOG_DATA) public user: User,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.usersLoaded();
  }

  override usersLoaded() {
    this.usersFiltered = this.users.filter(u => u.status == 1);
  }

  getUserSelected(isSelected: boolean, user: User) {
    if (isSelected) {
      this.userSelected = user;
    }
  }

  add() {
    if (this.userSelected?.id != undefined) {
      this.dialogRef.close(this.userSelected);
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  filter(e: any) {
    const code = e.target.code;
    const value = e.target.value;
    if (!code?.includes('Arrow')) {
      this.usersFiltered = this.usersFiltered?.filter(x => x.name?.toLowerCase().includes(value.trim().toLowerCase()));
    }
  }

}
